import { Navigate, useLocation } from "react-router";


import HeaderComponent from "../components/HeaderComponent/HeaderComponent";
import Sidebar from "../components/SidebarComponent/Sidebar";
import { useSelector } from "react-redux";

// userMode is store userSlice data, thats is cotrol login status
import { Account_Status, SelectedAccount, UserDetails, userlogout } from "../redux/userSlice";
import { themeMode } from "../redux/themeSlice";
import { useEffect, useState } from "react";
import axios from "axios";

const ProtectRouteusingvalue = ({ children }) => {
    const APi_Url = process.env.REACT_APP_ENIGMA_API;

  const selectedAccountDetails = useSelector(SelectedAccount);

 const account_status=useSelector(Account_Status);

  

 

  
   
  const isTokenValid = () => {
    const tokenData = JSON.parse(sessionStorage.getItem('token'));
  
    if (!tokenData) {
      return false;
    }
  
    const currentTime = new Date().getTime();
    
    
    const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
  
   
    if (currentTime - tokenData.timestamp > oneDay) {
      sessionStorage.removeItem('token');
      userlogout();
      return false;
    }
  
    return true;
  };
  
  const getToken = () => {
    if (isTokenValid()) {
      const tokenData = JSON.parse(sessionStorage.getItem('token'));
      return tokenData.value;
    }
    return null;
  };
    
const token=getToken();



   

    const thememode=useSelector(themeMode)

  let location = useLocation();
  if (!token ) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  else if(!account_status){
    return <Navigate to="/dashboard" state={{ from: location }} />;
  }
  else{
  return <div className={`mainsection ${thememode?"":"dark"}`}>
   <HeaderComponent />
   
      <Sidebar />
      <>
       {children}
      </>
 
  </div>;
  }
};

export default ProtectRouteusingvalue;
